import { CircularLoaderContainer } from '@/components/base/circular-loader-container.component';
import { Card } from '@mui/material';
import { useCart } from '@/api/carts/carts.hooks.ts';

export default function CustomerCtoRoute() {
  const { data: cartData, isPending } = useCart();
  const baseUrl = import.meta.env.VITE_API_BASE_URL;

  return (
    <Card
      elevation={2}
      sx={{
        width: '100%',
        mx: 'auto',
        height: {
          xs: 'calc(100dvh - 82px)',
          sm: 'calc(100dvh - 110px)',
        },
      }}
    >
      {isPending ? (
        <CircularLoaderContainer />
      ) : (
        <iframe
          style={{ width: '100%', height: '100%', border: 'none' }}
          src={`https://ctofinder.comline-shop.de/4DCGI/ezshop?hid=219&enter=directlogin&ctokey=KbsPfEhWJvMMNrM4yREFjck5hqqxDCjW&submit=Login&sprachnr=1&htmlpage=login_erfolg.htm&hookurl=${baseUrl}/v1/items/cto?cid=${cartData?.id}`}
        ></iframe>
      )}
    </Card>
  );
}
